import { Box, Grid, Stack, styled } from "@mui/material";
import DesktopSideImage from "../components/DesktopSideImage";
import GoogleRecaptcha from "../components/GoogleRecaptcha";
import HorizontalLinearStepper from "../components/HorizontalLinearStepper";
import Logo from "../components/Logo";
import StepOne from "../components/StepOne";
import StepThree from "../components/StepThree";
import StepTwo from "../components/StepTwo";

const RegistrationContentHolder = styled(Box)({
  display: "flex",
  alignItems: "cetner",
  flexDirection: "column",
  justifyContent: "space-around",
  height: "100%",
  paddingTop: "60px",
});

const MobileHeaderHolder = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "0",
  left: "0",
  right: "0",
  zIndex: "-1",
  height: "118px",
  background: "linear-gradient(#5F96CF, #0F4571)",
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

type TProps = {
  // Step handlers
  activeStep: number;
  handleReset: () => void;
  // API Handlers which will be passed to StepOne component
  handlePostTrueDryRun: () => void;
  // API Handlers which will be passed to StepTwo component
  handleSendOtpCall: () => Promise<boolean>;
  handlePostFalseDryRun: () => void;
  // Redirect function for step three
  handleRedirect: () => void;
  // inProgress flag for both step one and two
  inProgress: boolean;
  captchaAction: string;
};

export default function SubmitRegistrationView({
  activeStep,
  handleSendOtpCall,
  handlePostFalseDryRun,
  handlePostTrueDryRun,
  handleRedirect,
  inProgress,
  captchaAction,
}: TProps) {
  return (
    <>
      <MobileHeaderHolder />
      <GoogleRecaptcha captchaAction={captchaAction} />

      <Grid container sx={{ height: "100dvh" }}>
        <Grid item xs={12} md={8}>
          <RegistrationContentHolder>
            <Stack>
              <Logo />

              <HorizontalLinearStepper activeStep={activeStep} />
            </Stack>

            {activeStep === 0 && (
              <StepOne
                handlePostTrueDryRun={handlePostTrueDryRun}
                inProgress={inProgress}
              />
            )}

            {activeStep === 1 && (
              <StepTwo
                handlePostFalseDryRun={handlePostFalseDryRun}
                inProgress={inProgress}
                handleSendOtpCall={handleSendOtpCall}
              />
            )}

            {activeStep === 2 && <StepThree handleRedirect={handleRedirect} />}
          </RegistrationContentHolder>
        </Grid>

        <DesktopSideImage />
      </Grid>
    </>
  );
}
